<template>
  <!-- 운영 어시스턴트 FAB — 패널이 닫혀 있을 때만 노출.
       hover/focus 시 브리핑을 프리페치해, 클릭 시점엔 이미 도착해 있게 한다(2026-07-31). -->
  <button
    v-show="!store.open"
    class="aw-fab"
    type="button"
    :aria-label="$t('assistant.openAria')"
    @mouseenter="prefetchBriefing()"
    @focus="prefetchBriefing()"
    @click="store.toggle()"
  >
    <spike-mark />
  </button>
</template>

<script>
import { useAssistantStore } from '@/stores/assistant'
import { useAssistant } from '@/composables/useAssistant'
import SpikeMark from './SpikeMark.vue'

/**
 * @component AssistantFloatingButton
 * @description 어시스턴트를 여는 플로팅 액션 버튼. 상태는 Pinia 스토어 공유.
 * 키보드 토글(Ctrl+K)은 항상 마운트되는 AssistantWidget 컨테이너가 전역 처리한다.
 * hover/focus 로 브리핑을 선제 요청한다 — 렌더는 패널 오픈 시(useAssistant.sendBriefing).
 */
export default {
  name: 'AssistantFloatingButton',
  components: { SpikeMark },
  setup() {
    const store = useAssistantStore()
    const { prefetchBriefing } = useAssistant()
    return { store, prefetchBriefing }
  }
}
</script>

<style scoped>
.aw-fab {
  position: fixed;
  right: var(--fab-offset, 24px);
  bottom: var(--fab-offset, 24px);
  width: var(--fab-size, 60px);
  height: var(--fab-size, 60px);
  border-radius: var(--radius-full, 9999px);
  background: var(--color-primary-500, #3B5998);
  color: var(--color-white, #fff);
  border: none;
  cursor: pointer;
  box-shadow: var(--shadow-xl, 0 8px 24px rgba(0, 0, 0, 0.15));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2147483000;
  transition: transform 0.15s ease, background 0.15s ease;
}
.aw-fab:hover {
  background: var(--color-primary-600, #2C4578);
  transform: scale(1.05);
}
</style>
